import React, { forwardRef } from 'react'
import MinusIcon from '../icons/minus.svg'
import PlusIcon from '../icons/plus.svg'

interface IProps {
  value: string
  disabled?: boolean
  canDecrement?: boolean
  onChange: (value: string) => void
  onDecrement: () => void
  onIncrement: () => void
  onBlur?: () => void
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>
  testId?: string
}

const QuantityStepper = forwardRef<HTMLInputElement, IProps>(
  (
    {
      value,
      disabled,
      canDecrement = true,
      onChange,
      onDecrement,
      onIncrement,
      onBlur,
      onKeyDown,
      testId,
    },
    ref,
  ) => (
    <div className="stepper" data-testid={testId}>
      <button
        type="button"
        className="stepper_button -minus clear-button"
        disabled={disabled || !canDecrement}
        onClick={onDecrement}
        tabIndex={-1}
        aria-label="Decrease"
      >
        <MinusIcon />
      </button>
      <input
        ref={ref}
        className="stepper_input"
        type="number"
        value={value}
        disabled={disabled}
        onChange={(e) => onChange(e.target.value)}
        onFocus={(e) => e.target.select()}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        data-testid={testId && `${testId}-input`}
      />
      <button
        type="button"
        className="stepper_button -plus clear-button"
        disabled={disabled}
        onClick={onIncrement}
        tabIndex={-1}
        aria-label="Increase"
      >
        <PlusIcon />
      </button>
    </div>
  ),
)

export default QuantityStepper
